import React from "react";

export const FieldLabel = ({ label, children }) => (
  <label className="block">
    <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">{label}</span>
    <div className="mt-1.5">{children}</div>
  </label>
);


